<template>
  <v-dialog v-model="open" persistent max-width="640px">
    <v-card>
      <form @submit.prevent="!isProcessing ? onSubmit() : null" novalidate>
        <v-card-title>
          <span class="headline">Edycja użytkownika</span>
        </v-card-title>
        <v-card-text>
          <v-container style="padding-top: 0" grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Imię"
                  v-validate="'required'"
                  v-model="formData.name"
                  data-vv-name="imię"
                  :error-messages="errors.collect('imię')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Nazwisko"
                  v-validate="'required'"
                  v-model="formData.surname"
                  data-vv-name="nazwisko"
                  :error-messages="errors.collect('nazwisko')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Adres e-mail"
                  v-validate="'required|email'"
                  v-model="formData.email"
                  data-vv-name="email"
                  :error-messages="errors.collect('email')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="types"
                  label="Typ"
                  item-value="type"
                  item-text="label"
                  data-vv-name="typ"
                  v-model="formData.type"
                  :error-messages="errors.collect('typ')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$emit('close')">Anuluj</v-btn>
          <v-btn color="blue darken-1" type="submit" :disabled="isProcessing" flat>Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'EditUser',
    props: {
      open: Boolean,
      formData: Object,
    },
    data() {
      return {
        types: [{
          label: 'Administrator',
          type: 'A',
        }, {
          label: 'Użytkownik',
          type: 'U',
        }],
        isProcessing: false,
      };
    },
    methods: {
      ...mapActions('UserStore', ['updateUser']),
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              this.updateUser(this.formData)
                .then(() => {
                  this.isProcessing = false;
                  this.$emit('refresh');
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
